<template>
  <div class="page page-account">
    <b-col class="py-3">
      <GameHeader :page-name="$t('WebShop')"/>
      <RowLine />
      <div class="game-feature">
        <h1 class="feature-title">{{$t("WebShop")}}</h1>
        <ValidationObserver ref="form" tag="form" class="form app-form" @submit.prevent="onSubmit()">
          <b-form-group>
            <label>{{ $t("Server name") }}</label>
            <b-input v-model="serverName" readonly />
          </b-form-group>
          <b-form-group>
            <label>{{ $t("Character") }}</label>
            <b-input v-model="roleName" readonly />
          </b-form-group>
          <b-form-group v-if="gifts.length === 0">
            <NotFoundPanel/>
          </b-form-group>
          <b-form-group v-else>
            <b-row>
              <b-col cols="6" sm="4" md="3" v-for="(item, index) in gifts" :key="index" class="mb-3">
                <b-card>
                  <img :src="item.imageUrl.length ? item.imageUrl.getUrl() : '../../../assets/images/gift-newbie.png'" :alt="item.name" class="mb-3" style="display: block; max-width: 100%; margin: 0 auto;" />
                  <h4 style="font-size: 16px;" class="text-center mb-2">{{ item.name }}</h4>
                  <div class="text-center">
                    <b-button variant="primary" size="sm" @click="openDetail(item)">{{ $t("Claim") }}</b-button>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-form-group>
        </ValidationObserver>
        <LoadingModal :show="loading"/>
      </div>
    </b-col>
  </div>
</template>

<script>
import GameHeader from "@/components/headers/GameHeader";
import giftService from "@/services/giftService";
import webShopService from "@/services/webShopService";
import dialogHelper from "@/helpers/dialogHelper";

export default {
  name: "Index",
  components: {GameHeader},
  data() {
    return {
      loading: false,
      idGame: undefined,
      userName: undefined,
      serverName: undefined,
      roleName: undefined,
      gifts: []
    }
  },
  created() {
    this.$bridge.$on("setCurrentGame", this.loadGifts);
  },
  beforeDestroy() {
    this.$bridge.$off("setCurrentGame", this.loadGifts);
  },
  methods: {
    async loadGifts(game) {
      this.idGame = game.id;
      const {serverId, roleId, roleName} = this.$route.query;
      if (!serverId || !roleId || !roleName?.length) {
        await this.$gotoHomePage();
        return;
      }

      this.loading = true;
      const result = await giftService.getGifts({
        roleId: roleId,
        roleName: roleName,
        gameId: this.idGame,
        serverId: serverId
      });
      this.loading = false;
      if (!result || result.error) {
        await this.$gotoHomePage();
        return;
      }

      const data = result.data;
      this.roleName = data.roleName;
      this.serverName = data.serverName;
      this.userName = data.username;
      this.gifts = data.gifts;
    },
    claimed(result) {
      if (!result.id)
        return;

        this.gifts = [...this.gifts].filter(x => x.id !== result.id);
    },
    async openDetail(gift) {
      const {serverId, roleId, roleName} = this.$route.query;
      const panel = this.$showPanel({
        component: 'GiftPanel',
        openOn: "bottom",
        height: (window.innerHeight / 100) * 50,
        props: {
          gift: gift,
          gameId: this.idGame,
          roleId: roleId,
          roleName: roleName,
          serverId: serverId
        }
      });

      panel.promise.then(this.claimed);
    },
    async onSubmit(item) {
      if (!await dialogHelper.confirm(this.$t("Are you sure to buy {0}", [item.name])))
        return;


      this.formData.idWebShop = item.id;
      this.loading = true;
      await this.$recaptchaLoaded();
      const response = await webShopService.buy(this.formData, await this.$recaptcha('webshop'))
      this.loading = false;

      if (!response)
      {
        await dialogHelper.alert("Connect to server failed. Please check your internet connection");
        return;
      }

      if (response.error) {
        await dialogHelper.alert(response.message);
        return;
      }

      await dialogHelper.alert(response.message, "success");
      await this.loadPackages();
    }
  }
}
</script>
